//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { Normalized } from '@utils/normalize';

const getTikTokSummary = (state: ICuralateStore) => state.tiktok.summary;

export const getTikTokDeleteModalSelectedPostId = createSelector(
  getTikTokSummary,
  (tiktokSummary) =>
    tiktokSummary.modals.selectedPostIdForDeleteUpcomingScheduledPostModal,
);

export const getTikTokFetchUpcomingScheduledPostsError = createSelector(
  getTikTokSummary,
  (tiktokSummary) => tiktokSummary.errors.fetchUpcomingScheduledPostsError,
);

export const getTikTokIsDeletingUpcomingScheduledPost = createSelector(
  getTikTokSummary,
  (tiktokSummary) => tiktokSummary.flags.isDeletingUpcomingScheduledPost,
);

export const getTikTokIsDeleteUpcomingScheduledPostModalOpen = createSelector(
  getTikTokSummary,
  (tiktokSummary) =>
    tiktokSummary.modals.isDeleteUpcomingScheduledPostModalOpen,
);

export const getTikTokIsFetchingUpcomingScheduledPosts = createSelector(
  getTikTokSummary,
  (tiktokSummary) => tiktokSummary.flags.isFetchingUpcomingScheduledPosts,
);

export const getTikTokSummaryCurrentGraphMetric = createSelector(
  getTikTokSummary,
  (tiktokSummary) => tiktokSummary.currentGraphMetric,
);

export const getTikTokUpcomingScheduledPosts = createSelector(
  getTikTokSummary,
  (tiktokSummary) =>
    Normalized.getOrdered(tiktokSummary.upcomingScheduledPosts),
);
